import { render, staticRenderFns } from "./StudentRequirements.vue?vue&type=template&id=de930dc0&scoped=true"
import script from "./StudentRequirements.vue?vue&type=script&lang=js"
export * from "./StudentRequirements.vue?vue&type=script&lang=js"
import style0 from "./StudentRequirements.vue?vue&type=style&index=0&id=de930dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de930dc0",
  null
  
)

export default component.exports